import { Icon } from "@chakra-ui/react";
function ErrorIcon() {
  return (
    <Icon
      width="5"
      height="5"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      color="brand.alert.errorIconColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8369 17.5048H4.16541C3.24419 17.5048 2.49805 16.7586 2.49805 15.8374V10.8353C2.49805 9.91411 3.24419 9.16797 4.16541 9.16797H15.8369C16.7582 9.16797 17.5043 9.91411 17.5043 10.8353V15.8382C17.5043 16.7586 16.7582 17.5048 15.8369 17.5048Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.251 12.0859L8.75 14.587"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 12.0859L11.251 14.587"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0013 2.49805C10.9226 2.49805 11.6687 3.24419 11.6687 4.16541C11.6687 5.08662 10.9226 5.83277 10.0013 5.83277C9.08013 5.83277 8.33398 5.08662 8.33398 4.16541C8.33398 3.24419 9.08013 2.49805 10.0013 2.49805"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.81485 5.33594L4.98242 9.16837"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0033 9.15169L11.1875 5.33594"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default ErrorIcon;
